// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1E5FD","dragIcon":"SortableItem_dragIcon__2725L","disabled":"SortableItem_disabled__iz2rv"};